document.addEventListener("DOMContentLoaded", function () {
  const STORAGE_KEY = "tts_campaign";
  const QUERY_KEY = "campaign_param"
  const getValidParams = () => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];

    const now = new Date();
    try {
      const list = JSON.parse(raw);
      return Array.isArray(list)
        ? list.filter((item) => new Date(item.expire) > now)
        : [];
    } catch (e) {
      console.warn("localStorage parse error", e);
      return [];
    }
  };
  const queryValue = new URL(decodeURIComponent(document.location.href)).searchParams.get(QUERY_KEY)
  if(queryValue){
    const EXPIRE = new Date(Date.now() + 1000 * 60 * 60).toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify([{param: queryValue, expire: EXPIRE}]));
    document.getElementById("ReturnToInput").value = "/pages/tt_redirect";
  }else{
    const campaign_param = getValidParams();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(campaign_param));
    if (campaign_param.length >=1) {
      document.getElementById("ReturnToInput").value = "/pages/tt_redirect";
    }
  }
});
